import type { FC, ReactNode } from "react";
import PropTypes from "prop-types";
import Forbidden from "../pages/Forbidden";
import { usePermissions } from "src/hooks/usePermissions";

interface TemplateGuardProps {
  children: ReactNode;
}

const TextGuard: FC<TemplateGuardProps> = ({ children }) => {
  const { textChannelEnabled } = usePermissions();

  if (!textChannelEnabled) {
    return <Forbidden />;
  }

  return <>{children}</>;
};

TextGuard.propTypes = {
  children: PropTypes.node,
};

export default TextGuard;
